import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-request-reset',
    templateUrl: './request-reset.component.html',
    styleUrls: ['./request-reset.component.scss']
})
export class RequestResetComponent implements OnInit {

    public requestResetForm: FormGroup;
    public done: boolean;
    public errors = [];
    public needsVerify: boolean;

    constructor(private readonly formBuilder: FormBuilder, private readonly authService: AuthService) {}

    public ngOnInit() {
        this.requestResetForm = this.formBuilder.group({
            email: ['', Validators.required]
        });
    }

    public onSubmit() {
        if (this.requestResetForm.invalid) {
            return;
        }

        this.done = false;
        this.errors = [];
        this.needsVerify = false;

        this.authService.requestResetPassword({email: this.requestResetForm.controls.email.value})
            .subscribe(() => this.done = true, error => {
                // eslint-disable-next-line no-magic-numbers
                if (error.status === 423) {
                    this.errors.push('You must verify your email account first! Please check your inbox.');
                    this.needsVerify = true;
                } else {
                    this.errors.push('An unknown error has occurred!');
                }
            });
    }

    public resendVerify() {
        this.authService.resendVerify(this.requestResetForm.controls.email.value).subscribe(() => this.done = true);
    }
}
